import { TestarossaReadyState as TestarossaReadyStateComponent } from './TestarossaReadyState'

export default TestarossaReadyStateComponent
// eslint-disable-next-line import/export
export * from './TestarossaReadyState'
